import Vue from 'vue'
import VueRouter from 'vue-router'
import lianyunyidong from '../views/lianyunyidong/index.vue'

Vue.use(VueRouter)

const routes = [
    {
    path: '/',
    redirect: "/lianyunyidong"
  },
  {
    path: '/lianyunyidong',
    name: 'lianyunyidong',
    component: lianyunyidong
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
